import { render, staticRenderFns } from "./Verificator.vue?vue&type=template&id=bd0227cc&scoped=true"
import script from "./Verificator.vue?vue&type=script&lang=js"
export * from "./Verificator.vue?vue&type=script&lang=js"
import style0 from "./Verificator.vue?vue&type=style&index=0&id=bd0227cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0227cc",
  null
  
)

export default component.exports